export default __webpack_public_path__ + "static/media/skewBig.55fa07c9.png";